import { File } from 'better-xlsx';
import { saveAs } from 'file-saver';
import moment from 'moment';
import { IGuestReservationItem } from '../models/guestReservation.model';
import { getCommonCodeLabel } from './store';
import { addHyphen } from './util';

const COLOR_HEADER_BG = 'BB0665';
const COLOR_WHITE = 'FFFFFFFF';
const ROW_HEIGHT_CM = 0.8;

const setHeaderStyle = (cell: any) => {
  cell.style.fill.patternType = 'solid';
  cell.style.fill.fgColor = COLOR_HEADER_BG;
  cell.style.fill.bgColor = COLOR_HEADER_BG;
  cell.style.font.color = COLOR_WHITE;
  cell.style.font.bold = true;
  cell.style.align.h = 'center';
  cell.style.align.v = 'center';
};

const setDataStyle = (cell: any) => {
  cell.style.align.h = 'center';
  cell.style.align.v = 'center';
};

const HEADERS = [
  '번호',
  '캠퍼스명',
  '문의 시간',
  '학생명',
  '학교명',
  '학년',
  '학부모명',
  '학부모 연락처',
  '마케팅 동의',
  '입학테스트 희망일',
  '학부모 연락',
  '입학시험 응시',
  '회원가입',
];

// 엑셀은 폭 제약이 없어 일시를 그대로 남긴다.
const toYnOrDttm = (yn: string, dttm: string | null): string => {
  if (yn !== 'Y') return 'X';
  if (!dttm) return 'O';
  return moment(dttm).format('YYYY.MM.DD HH:mm');
};

const toRow = (item: IGuestReservationItem): string[] => [
  String(item.resvCode),
  item.campusName,
  item.firstRegDttm ? moment(item.firstRegDttm).format('YYYY.MM.DD HH:mm:ss') : '',
  item.studentName,
  item.schoolName,
  getCommonCodeLabel('SY0006', item.gradeCode, 'ko'),
  item.parentName,
  item.parentMobilePhone ? addHyphen(item.parentMobilePhone) : '-',
  item.marketingAgreeYn === 'Y' ? 'O' : 'X',
  item.examDate
    ? `${moment(item.examDate, 'YYYYMMDD').format('YYYY.MM.DD')} ${item.examTime || ''}`.trim()
    : '',
  getCommonCodeLabel('GM0001', item.contactStatusCode, 'ko'),
  toYnOrDttm(item.attendYn, item.attendDttm),
  toYnOrDttm(item.memberJoinYn, item.memberJoinDttm),
];

const exportGuestReservation = (data: IGuestReservationItem[]) => {
  if (!data.length) return;

  const file = new File();
  const sheet = file.addSheet('비회원 입학시험 예약');

  const headerRow = sheet.addRow();
  headerRow.setHeightCM(ROW_HEIGHT_CM);
  HEADERS.forEach((title) => {
    const cell = headerRow.addCell();
    cell.value = title;
    setHeaderStyle(cell);
  });

  data.forEach((item) => {
    const row = sheet.addRow();
    row.setHeightCM(ROW_HEIGHT_CM);
    toRow(item).forEach((value) => {
      const cell = row.addCell();
      cell.value = value;
      setDataStyle(cell);
    });
  });

  HEADERS.forEach((_, index) => {
    sheet.col(index).width = 20;
  });

  const fileName = `CANB_비회원입학예약_${moment().format('YYYYMMDD')}`;
  file.saveAs('blob').then((content: Blob) => {
    saveAs(content, `${fileName}.xlsx`);
  });
};

export default exportGuestReservation;
